import * as React from 'react';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(
        'h-9 w-full min-w-0 rounded-md border border-brand-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-brand-foreground placeholder:text-brand-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-brand-ring focus-visible:ring-[3px] focus-visible:ring-brand-ring/50',
        'aria-invalid:border-brand-destructive aria-invalid:ring-brand-destructive/20',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
